/**
 * StudioForty9 free shipping motivator
 * Javascript assets
 */

if (typeof Shopify === 'undefined') window.Shopify = {};
if (typeof Shopify.theme === 'undefined') Shopify.theme = {};
if (typeof Shopify.theme.jsMotivator === 'undefined') {
  Shopify.theme.jsMotivator = {
    arrayMotivators: false,
    self: null,
    init: function () {
      self = this;
      document.addEventListener('e_ajax-cart-changed', this.update);
      this.update();
    },
    update: () => {
      var _document$querySelect;
      self.arrayMotivators = [...document.querySelectorAll('[data-motivator]')];
      let cartTotal = (_document$querySelect = document.querySelector('[data-ajax-cart] [data-cart-total]')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.dataset.cartTotal,
        cartAmount = +cartTotal / 100;
      if (cartAmount == 0) {
        [...document.querySelectorAll('[data-motivator-success], [data-motivator-counter]')].forEach(item => item.style.display = 'none');
        [...document.querySelectorAll('[data-motivator-message]')].forEach(item => item.style.display = 'block');
      } else {
        self.arrayMotivators.forEach(motivator => {
          const targetAmount = motivator.dataset.targetAmount,
            currency = motivator.dataset.currency;
          if (cartAmount >= targetAmount) {
            [...motivator.querySelectorAll('[data-motivator-message], [data-motivator-counter]')].forEach(item => item.style.display = 'none');
            [...motivator.querySelectorAll('[data-motivator-success]')].forEach(item => item.style.display = 'block');
          } else {
            const remainder = (targetAmount - cartAmount).toFixed(2);
            [...motivator.querySelectorAll('[data-motivator-remainder]')].forEach(item => item.textContent = currency + remainder);
            [...motivator.querySelectorAll('[data-motivator-message], [data-motivator-success]')].forEach(item => item.style.display = 'none');
            [...motivator.querySelectorAll('[data-motivator-counter]')].forEach(item => item.style.display = 'block');
          }
        });
      }
    }
  };
}
Shopify.theme.jsMotivator.init();
